import { render, staticRenderFns } from "./PesquisadorLista.vue?vue&type=template&id=63a0f52e&"
import script from "./PesquisadorLista.vue?vue&type=script&lang=js&"
export * from "./PesquisadorLista.vue?vue&type=script&lang=js&"
import style0 from "./PesquisadorLista.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports